import React from 'react'
import Box from '@material-ui/core/Box'
import TrustPilotStarRating from './TrustPilotStarRating'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import useTrustPilot from '@talentinc/gatsby-theme-ecom/hooks/useTrustPilot'

interface Props {
  className?: string
  legendClass?: string
}

const StarsWidget: React.FC<Props> = ({ className, legendClass }) => {
  const classes = useStyles()
  const trustPilot = useTrustPilot()
  const { t } = useTranslation()

  if (!trustPilot) {
    return null
  }

  return (
    <Box className={clsx(className, classes.root)}>
      <TrustPilotStarRating
        boxClass={classes.rating}
        iconClass={classes.starIcon}
        rating={Math.ceil(trustPilot.businessUnit.trustScore * 2) / 2}
      />
      <Typography className={clsx(legendClass)} component="legend">
        {t('trustpilot.starsWidgetLegend', {
          rating: trustPilot.businessUnit.trustScore,
          reviewCount: trustPilot.businessUnit.numberOfReviews.total,
        })}
      </Typography>
    </Box>
  )
}

const useStyles = makeStyles((theme) =>
  createStyles({
    rating: {
      marginRight: '.39em',
    },
    root: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
    },
    starIcon: {
      height: '1.6rem',
    },
  })
)

export default StarsWidget
